import { Link, useParams } from "react-router-dom"
import { aprobarDesaprobar } from "../../redux/actions/actionDocument";
import { APROBADO, DESAPROBADO } from "../../Constantes/constantesFiltros";
import { useDispatch } from "react-redux";
import { format } from "date-fns";

export default function AprobacionPreOrdenCard({id, addressEvent, dateReception, dateSend, numberDocument, name_client, approved }){
    const dispatch = useDispatch();
    //const {id} = useParams();

    const handleAprobar = (e) => {
        const { value } = e.target
        console.log(value)
        if(value === APROBADO){
            dispatch(aprobarDesaprobar(id, {
                
                aprobado: true
            }))
        }        
    }
    
    
    return (
        <div className="flex flex-row">
            <Link to={`/documentos/${id}`}>
            <div className='flex flex-row  bg-slate-300 hover:text-slate-400'>
                <div className='border-b-2 border-white w-12'>                    
                    <p className="text-[11px] font-bold text-center">{numberDocument}</p>
                </div>
                <div className='border-b-2 border-white pl-2 w-60'>                    
                    <p className="text-[11px] font-bold text-left pl-2">{name_client}</p>
                </div>
                <div className='border-b-2 border-white pl-2 w-80'>                    
                    <p className="text-[11px] font-bold text-left pl-2">{addressEvent}</p>
                </div>
                <div className='border-b-2 border-white w-20'>                    
                    <p className="text-[11px] font-bold text-center">{dateSend ? format(new Date(dateSend), "dd/MM/yyyy") : null}</p>
                </div>
                <div className='border-b-2 border-white w-20'>                    
                    <p className="text-[11px] font-bold text-center">{dateReception ? format(new Date(dateReception), "dd/MM/yyyy") : null}</p>
                </div>                
                </div>
            </Link> 
            <div className="flex flex-row text-[8pt] border-b-2 border-white">
                     
                    <div className="bg-green-700 w-20 text-center hover:bg-green-400">
                        <button className="text-black font-bold hover:text-white" value={APROBADO} onClick={handleAprobar}>
                            Aprobar
                        </button>
                    </div>
                    {/* <div className="bg-red-700 w-20 text-center hover:bg-red-400">
                        <button className="text-black font-bold hover:text-white" value={DESAPROBADO} onClick={handleAprobar}>
                            Desaprobar
                        </button>
                    </div> */}
                </div>  
        </div>
    )
}